import { Injectable } from '@angular/core'
import { KirjanpitajienRoolitUriService } from '@lemon/core-firebase/lemonator/service/kirjanpitajien-roolit-uri.service'
import { BankConsentUriService } from '@lemon/core-firebase/service/bank-consent-uri.service'
import { BitService } from '@lemon/core-firebase/service/bit.service'
import { KopioijaPalvelu } from '@lemon/core-firebase/service/kopioija.service'
import { ToimittajaTunnisteService } from '@lemon/core-firebase/service/lasku/toimittaja-tunniste.service'
import { TranslationService } from '@lemon/core-firebase/service/translation.service'
import { TuotteetService } from '@lemon/core-firebase/service/tuotteet-service'
import { VatNumberValidationService } from '@lemon/core-firebase/service/vat-number-validation.service'
import { CodeCheckService } from '@lemon/core/service/code-check.service'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'
import { PyhapaivatService } from '@lemon/core/service/pyhapaiva.service'
import { StringService } from '@lemon/core/service/string.service'
import { TimestampProviderBase } from '@lemon/core/service/timestamp-provider.interface'
import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { TimestampService } from 'app/_jaettu-angular/service/timestamp-service'
import { KirjanpitajienTiimit } from 'app/_jaettu-lemonator/model/kirjanpitaja'
import { ArkistoService } from 'app/_jaettu-lemonator/service/arkisto.service'
import { AsiakasUriService } from 'app/_jaettu-lemonator/service/asiakas-uri.service'
import { EmailTemplatesUriService } from 'app/_jaettu-lemonator/service/email-templates-uri.service'
import { HolviSharedUriService } from 'app/_jaettu-lemonator/service/holvi-shared-uri.service'
import { KirjanpitajanAllekirjoitusService } from 'app/_jaettu-lemonator/service/kirjanpitajan-allekirjoitus.service'
import { KirjanpitajanTiimiService } from 'app/_jaettu-lemonator/service/kirjanpitajan-tiimi.service'
import { KirjanpitoReskontraUriService } from 'app/_jaettu-lemonator/service/kirjanpito-reskontra-uri.service'
import { LlmTositeLukuMetatiedotService } from 'app/_jaettu-lemonator/service/llm-tosite-luku-metatiedot.service'
import { PoistotService } from 'app/_jaettu-lemonator/service/poistot.service'
import { AsiakkaanSopimuskausiService } from 'app/_jaettu-lemonator/service/sopimuskausi.service'
import { TilinpaatosLiitetiedotJaettuService } from 'app/_jaettu-lemonator/service/tilinpaatos-liitetiedot-jaettu.service'
import { TilinpaatosTranslationService } from 'app/_jaettu-lemonator/service/tilinpaatos-translation.service'
import { TilinpaatosUsersService } from 'app/_jaettu-lemonator/service/tilinpaatos-users.service'
import { TilintarkastajaUriService } from 'app/_jaettu-lemonator/service/tilintarkastaja-uri.service'
import { TilintarkastajaService } from 'app/_jaettu-lemonator/service/tilintarkastaja.service'
import { VeloituksetService } from 'app/_jaettu-lemonator/service/veloitukset-service'
import { VeroilmoitusLaskentaService } from 'app/_jaettu-lemonator/service/veroilmoitus/veroilmoitus-laskenta.service'
import { from, of, switchMap } from 'rxjs'
import { AsiakasJaettuService } from '../_jaettu-lemonator/service/asiakas-jaettu.service'
import { KirjanpitajanToimipisteService } from '../_jaettu-lemonator/service/kirjanpitajan-toimipiste.service'
import { KirjanpitoJaettuService } from '../_jaettu-lemonator/service/kirjanpito-jaettu.service'
import { KirjanpitoUriService } from '../_jaettu-lemonator/service/kirjanpito-uri.service'
import { SopimusUriService } from '../_jaettu-lemonator/service/sopimus-uri.service'
import { TilikarttaJaettuService } from '../_jaettu-lemonator/service/tilikartta-jaettu.service'
import { VeroilmoitusTranslationService } from '../_jaettu-lemonator/service/veroilmoitus/veroilmoitus-translation.service'
import { YllapitoUriService } from '../_jaettu-lemonator/service/yllapito-uri.service'

@Injectable()
export class KirjanpitajanTiimiServiceAngular extends KirjanpitajanTiimiService {
  constructor(dateServic: DateService, copyService: KopioijaPalvelu, firebaseLemonator: FirebaseLemonator, yllapitoUriService: YllapitoUriService) {
    // Kytketään Firestore-snapshot-kuuntelija data-lähteeksi. Kirjoitukset näkyvät myös kuuntelijalla, joten
    // erillistä cache-invalidointia ei tarvita. Auth-tila otetaan suoraan FirebaseLemonator.authUserObservable:lta,
    // jottei tarvita KirjautunutKayttajaService-injektiota — se aiheuttaisi DI-syklin
    // (KirjautunutKayttajaService injektoi tämän palvelun konstruktorissa).
    super(dateServic, copyService, provideData => {
      firebaseLemonator.authUserObservable
        .pipe(
          switchMap(user => {
            if (!user) {
              return of(null)
            }
            return from(user.getIdTokenResult()).pipe(
              switchMap(token => {
                if (!token.claims?.kirjanpitaja) {
                  return of(null)
                }
                return firebaseLemonator.firestoreDoc<KirjanpitajienTiimit>(yllapitoUriService.annaKirjanpitajienTiimitUri()).listen()
              }),
            )
          }),
        )
        .subscribe(dokumentti => {
          provideData(
            dokumentti ?? {
              tiimikokonaisuudet: {},
              tiimit: {},
            },
          )
        })
    })
  }
}
@Injectable()
export class BitServiceAngular extends BitService {
  constructor() {
    super()
  }
}

@Injectable()
export class AsiakasUriServiceAngular extends AsiakasUriService {
  constructor() {
    super()
  }
}

@Injectable()
export class AsiakasJaettuServiceAngular extends AsiakasJaettuService {
  constructor(dateService: DateService, currencyService: CurrencyService, sopimuskausiService: AsiakkaanSopimuskausiService) {
    super(dateService, currencyService, sopimuskausiService)
  }
}

@Injectable()
export class KirjanpitoJaettuServiceAngular extends KirjanpitoJaettuService {
  constructor(
    currencyService: CurrencyService,
    dateService: DateService,
    asiakasJaettuService: AsiakasJaettuService,
    pyhapaivatService: PyhapaivatService,
    translationService: TranslationService,
    tilikarttaJaettuService: TilikarttaJaettuService,
    vatValidationService: VatNumberValidationService,
  ) {
    super(currencyService, dateService, asiakasJaettuService, pyhapaivatService, translationService, tilikarttaJaettuService, vatValidationService)
  }
}

@Injectable()
export class KirjanpitoUriServiceAngular extends KirjanpitoUriService {
  constructor() {
    super()
  }
}

@Injectable()
export class TilikarttaJaettuServiceAngular extends TilikarttaJaettuService {
  constructor(kopioijaPalvelu: KopioijaPalvelu, dateService: DateService) {
    super(kopioijaPalvelu, dateService)
  }
}

@Injectable()
export class YllapitoUriServiceAngular extends YllapitoUriService {
  constructor() {
    super()
  }
}
@Injectable()
export class KirjanpitajienRoolitUriServiceAngular extends KirjanpitajienRoolitUriService {
  constructor() {
    super()
  }
}
@Injectable()
export class PyhapaivatServiceAngular extends PyhapaivatService {
  constructor(dateService: DateService) {
    super(dateService)
  }
}

@Injectable()
export class VeroilmoitusTranslationServiceAngular extends VeroilmoitusTranslationService {
  constructor() {
    super()
  }
}
@Injectable()
export class KirjanpitajanToimipisteServiceAngular extends KirjanpitajanToimipisteService {
  constructor() {
    super()
  }
}

@Injectable()
export class KirjanpitajanAllekirjoitusServiceAngular extends KirjanpitajanAllekirjoitusService {
  constructor(kirjanpitajanToimipisteService: KirjanpitajanToimipisteService, kirjanpitajanTiimiService: KirjanpitajanTiimiService, dateService: DateService) {
    super(kirjanpitajanToimipisteService, kirjanpitajanTiimiService, dateService)
  }
}
@Injectable()
export class HolviSharedUriServiceAngular extends HolviSharedUriService {
  constructor() {
    super()
  }
}

@Injectable()
export class SopimusUriServiceAngular extends SopimusUriService {
  constructor() {
    super()
  }
}

@Injectable()
export class TilinpaatosTranslationServiceAngular extends TilinpaatosTranslationService {
  constructor() {
    super()
  }
}

@Injectable()
export class TilinpaatosLiitetiedotJaettuServiceAngular extends TilinpaatosLiitetiedotJaettuService {
  constructor(dateService: DateService, currencyService: CurrencyService, timestampService: TimestampService) {
    super(dateService, currencyService, timestampService)
  }
}

@Injectable()
export class AsiakkaanSopimuskausiServiceAngular extends AsiakkaanSopimuskausiService {
  constructor(dateService: DateService, timestampService: TimestampService) {
    super(dateService, timestampService)
  }
}

@Injectable()
export class TuotteetServiceAngular extends TuotteetService {
  constructor() {
    super()
  }
}

@Injectable()
export class VeloituksetServiceAngular extends VeloituksetService {
  constructor(dateService: DateService, tuotteetService: TuotteetService) {
    super(dateService, tuotteetService)
  }
}

@Injectable()
export class ArkistoServiceAngular extends ArkistoService {
  constructor() {
    super()
  }
}

@Injectable()
export class EmailTemplatesUriServiceAngular extends EmailTemplatesUriService {
  constructor() {
    super()
  }
}

@Injectable()
export class BankConsentUriServiceAngular extends BankConsentUriService {
  constructor() {
    super()
  }
}

@Injectable()
export class KirjanpitoReskontraUriServiceAngular extends KirjanpitoReskontraUriService {
  constructor() {
    super()
  }
}

@Injectable()
export class TilinpaatosUsersServiceAngular extends TilinpaatosUsersService {
  constructor(stringService: StringService, translationService: TranslationService) {
    super(stringService, translationService)
  }
}

@Injectable()
export class VeroilmoitusLaskentaServiceAngular extends VeroilmoitusLaskentaService {
  constructor(dateService: DateService, currencyService: CurrencyService, codeCheckService: CodeCheckService, asiakasJaettuService: AsiakasJaettuService) {
    super(dateService, currencyService, codeCheckService, asiakasJaettuService)
  }
}

@Injectable()
export class PoistotServiceAngular extends PoistotService {
  constructor(dateService: DateService, currencyService: CurrencyService) {
    super(dateService, currencyService)
  }
}

@Injectable()
export class LlmTositeLukuMetatiedotServiceAngular extends LlmTositeLukuMetatiedotService {
  constructor(toimittajaTunnisteService: ToimittajaTunnisteService, codeCheckService: CodeCheckService) {
    super(toimittajaTunnisteService, codeCheckService)
  }
}

@Injectable()
export class TilintarkastajaServiceAngular extends TilintarkastajaService {
  constructor(tilintarkastajaUriService: TilintarkastajaUriService, timestampProviderBase: TimestampProviderBase, kopioijaPalvelu: KopioijaPalvelu, firebaseLemonator: FirebaseLemonator) {
    super(tilintarkastajaUriService, timestampProviderBase, kopioijaPalvelu, firebaseLemonator.firestoreProvider)
  }
}
